export default "__VITE_ASSET__CY2bAOiS__"